// Copyright 2017-2022 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { hasBigInt, u8aToHex, u8aToU8a } from '@polkadot/util';
import { isReady } from '@polkadot/wasm-crypto'; // re-export so TS *.d.ts generation is correct

export function createAsHex(fn) {
  return function () {
    return u8aToHex(fn.apply(void 0, arguments));
  };
}
export function createBitHasher(bitLength, fn) {
  return function (data, onlyJs) {
    return fn(data, bitLength, onlyJs);
  };
}
export function createDualHasher(wa, js) {
  return function (value) {
    var bitLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 256;
    var onlyJs = arguments.length > 2 ? arguments[2] : undefined;
    var u8a = u8aToU8a(value);
    return !hasBigInt || !onlyJs && isReady() ? wa[bitLength](u8a) : js[bitLength](u8a);
  };
}